import { Image } from '@vinted/web-ui';
import UserImage from 'components/UserImage';
import { jsx as _jsx } from "react/jsx-runtime";

const FeedbackThumbnail = _ref => {
  let {
    user,
    size,
    isSystem
  } = _ref;

  if (isSystem) {
    return /*#__PURE__*/_jsx(UserImage, {
      styling: Image.Styling.Circle,
      size: size,
      isSystem: true
    });
  }

  if (user) {
    return /*#__PURE__*/_jsx("a", {
      href: user.profileUrl,
      children: /*#__PURE__*/_jsx(UserImage, {
        styling: Image.Styling.Circle,
        size: size,
        src: user.photoUrl
      })
    });
  }

  return /*#__PURE__*/_jsx(UserImage, {
    styling: Image.Styling.Circle,
    size: size
  });
};

export default FeedbackThumbnail;